import { render, staticRenderFns } from "./summary-customer-sales-by-product.vue?vue&type=template&id=630b9366&scoped=true&"
import script from "./summary-customer-sales-by-product.vue?vue&type=script&lang=js&"
export * from "./summary-customer-sales-by-product.vue?vue&type=script&lang=js&"
import style0 from "./summary-customer-sales-by-product.vue?vue&type=style&index=0&id=630b9366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b9366",
  null
  
)

export default component.exports